<div class="SLV2-completion-pg-wrap">

    <!-- header start -->
    <div class="SLV2-completion-hdr">
        <div class="SLV2-completion-hdr-title-row">
            <button class="SLV2-completion-close-btn" (click)="navigateToChapterPractice()">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/left-blue-arrow.svg" class="white-filter mob-arrow" />
                <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" class="desk-arrow" />
            </button>
        </div>
    </div>
    <!-- header ended -->

    <!-- question box start -->
    <div class="SLV2-completion-body-wrap">
        <div class="SLV2-completion-box">

            <h3 class="SLV2-completion-hdng">{{getTopicName()}}</h3>

            <img src="selflearnv2-ui/assets/img/animation-champion-icon.gif" class="SLV2-champion-icon" />
            <h4 class="SLV2-champion-gritting-title">Well done!</h4>
            <h5 class="SLV2-champion-level-title">All levels completed.</h5>
            <!-- <button class="SLV2-completion-text-btn sm">Practice more of same topic <img src="assets/img/self-learn-v2/right-blue-arrow.svg" class="right" /></button> -->

            <div class="SLV2-completion-report-box">
                <h4 class="SLV2-completion-report-title">Attempts analysis</h4>

                <div class="SLV2-completion-chart-area">
                    <apx-chart [series]="donutchartOptions1.series" [chart]="donutchartOptions1.chart" [labels]="donutchartOptions1.labels" [dataLabels]="donutchartOptions1.dataLabels" [legend]="donutchartOptions1.legend" [responsive]="donutchartOptions1.responsive" [tooltip]="donutchartOptions1.tooltip" [fill]="donutchartOptions1.fill" [stroke]="donutchartOptions1.stroke" [states]="donutchartOptions1.states" [plotOptions]="donutchartOptions1.plotOptions" class="SLV2-completion-donut"></apx-chart>
                    <ul class="SLV2-chrt-infolist">
                        <li>
                            <div class="SLV2-scr-infobx lstview">
                                <h2 class="scr-info-titl"><span
                                        class="crt-dot green"></span>Correct</h2>
                                <div class="scr-info-cunt"> {{practiceAnalysis?.correct}} Q’s</div>
                            </div>
                        </li>
                        <li>
                            <div class="SLV2-scr-infobx lstview">
                                <h2 class="scr-info-titl"><span
                                        class="crt-dot red"></span>Incorrect</h2>
                                <div class="scr-info-cunt"> {{practiceAnalysis?.inCorrect}} Q’s</div>
                            </div>
                        </li>
                        <li>
                            <div class="SLV2-scr-infobx lstview">
                                <h2 class="scr-info-titl"><span
                                        class="crt-dot"></span>Not answered</h2>
                                <div class="scr-info-cunt"> {{practiceAnalysis?.notAnswered}} Q’s</div>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>

            <div class="SLV2-completion-actn-area" *ngIf="!isLastTopic()">
                <button class="SLV2-completion-solid-btn" (click)="goToNextTopic()">Go to Next Topic</button>
                <!-- <button class="SLV2-completion-text-btn">View solutions</button> -->
            </div>
            <div class="SLV2-completion-actn-area" *ngIf="isLastTopic()">
                <button class="SLV2-completion-solid-btn" (click)="navigateToChapterPractice()">Continue Learning</button>
                <!-- <button class="SLV2-completion-text-btn">View solutions</button> -->
            </div>
        </div>
    </div>
    <!-- question box ended -->


</div>